import './MenuDropdown.scss';

import { useState } from "react";

import { KeyboardArrowDown } from "@mui/icons-material";
import { KeyboardArrowUp } from "@mui/icons-material";

export const MenuDropdown = ({Icon, title, chipTitle, active = false, links = []}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div className={`menu-dropdown ${active ? "--active" : ""}`}>
            <div className={"menu-dropdown_container"} onClick={active ? toggleDropdown : null}>
                <div className={"menu-dropdown_left-section"}>
                    <div className={"menu-dropdown_title"}>
                        {Icon && <Icon style={{fontSize: "18px"}}/>}
                        {title}
                    </div>
                </div>
                <div className={"menu-dropdown_right-section"}>
                    {chipTitle && (
                        <div className={"menu-dropdown_chip"}>
                            {chipTitle}
                        </div>
                    )}
                    {active && (
                        <div className={"menu-dropdown_toggle"}>
                            {!isOpen ?
                                <KeyboardArrowDown style={{fontSize: "18px"}}/> :
                                <KeyboardArrowUp style={{fontSize: "18px"}}/>}
                        </div>
                    )}
                </div>
            </div>
            {isOpen && (
                <div className={"menu-dropdown_links"}>
                    {links.map((link, index) => (
                        <div key={index} className={"menu-dropdown_link"}>
                            {link}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}